module.exports = __webpack_public_path__ + "img/panel_highrisk_off.99284cd0.svg";